<script setup>
import { ref } from 'vue';
import axios from 'axios';
import RegisterContainer from '@/components/Auth/RegisterContainer';
import { useToast } from 'vue-toastification';

const toast = useToast();

const props = defineProps({
    emailVerified: {
        type: Boolean,
        default: false
    }
});

const isResending = ref(false);

const resendVerification = async () => {
    isResending.value = true;
    try {
        await axios.post('/email/verification-notification');
        toast.success('Verification link sent!');
    } catch {
        toast.error('Failed to send verification link.');
    } finally {
        isResending.value = false;
    }
};

</script>
<template>
<RegisterContainer>
    <template #title>{{ $t('auth.register.verify_email') }}</template>
    <div class="mb-4">
        <p v-if="props.emailVerified" class="text-green-600">{{ $t('auth.register.email_verified') }}</p>
        <p v-else class="text-gray-700">{{ $t('auth.register.verify_email_instruction') }}</p>
    </div>
    <StyledButton
        type="button"
        color="secondary"
        :loading="isResending"
        @click="resendVerification">
        {{ $t('auth.register.resend_verification') }}
    </StyledButton>
</RegisterContainer>
</template>

